import { CircleMarker, MapContainer, Popup, TileLayer } from 'react-leaflet'
import { Link } from 'react-router-dom'
import type { Warehouse } from '../types'

export default function WarehouseMap({items}:{items:Warehouse[]}) {
  const visible = items.filter(i => Number.isFinite(Number(i.latitude)) && Number.isFinite(Number(i.longitude)))
  return <MapContainer className="warehouse-map" center={[61.5,94.5]} zoom={3} scrollWheelZoom>
    <TileLayer attribution='&copy; OpenStreetMap contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
    {visible.map(item => <CircleMarker key={item.id} center={[Number(item.latitude),Number(item.longitude)]} radius={9} pathOptions={{fillOpacity:.85}}>
      <Popup><b>{item.title}</b><br/>{item.city_name}<br/><Link to={`/warehouse/${item.slug}`}>Открыть карточку</Link></Popup>
    </CircleMarker>)}
  </MapContainer>
}
